import { AmbientLight, DirectionalLight } from 'three'

/**
 * Lights
 */
const ambientLight = new AmbientLight(0xffffff, 2.1)

const directionalLight = new DirectionalLight(0xffffff, 0.6)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.left = - 7
directionalLight.shadow.camera.top = 7
directionalLight.shadow.camera.right = 7
directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(5, 5, 5)

export {
    ambientLight,
    directionalLight,
}
